import React from 'react';

import { SvgIcon } from '@components/icon';
import StyledCheckbox from '@components/shared/checkbox';
import { BaseText } from '@components/shared/common';
import {
  CheckboxLabels,
  CheckboxWrapper,
  CheckIcon,
} from '@components/shared/form/checkbox-wrapper';
import { FormRadioProps } from '@models/common/form';

const Radio: React.FunctionComponent<FormRadioProps> = ({
  label,
  secondaryLabel,
  id,
  ...props
}) => (
  <CheckboxWrapper>
    <StyledCheckbox id={id} type="radio" {...props} />
    <CheckboxLabels className="pointer" htmlFor={id}>
      <CheckIcon>
        <SvgIcon width="32" src="checked.svg" alt="Checked" />
      </CheckIcon>
      <div>
        <BaseText fWeight="500">{label}</BaseText>
        {secondaryLabel && (
          <BaseText fWeight="300" itemWidth="100%" mItemWidth="100%">
            {secondaryLabel}
          </BaseText>
        )}
      </div>
    </CheckboxLabels>
  </CheckboxWrapper>
);

export default Radio;
